import { useEffect, useState } from 'react'
import { Grid, styled } from '@mui/material'
import { useMediaQuery, useTheme } from '@mui/material'
import { LaunchOutlined } from '@mui/icons-material'
import { Button } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'app/state'

import HomeBlogCard from './HomeBlogCard'
import CardGroupHeader from 'features/common/ui/Cards/CardGroupHeader/CardGroupHeader'

const TitleContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end'
}))

const TitleButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}))

function HomeBlogLatestPosts() {
  const theme = useTheme()
  const isLargeOrUpScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const blogPosts = useAppSelector((state) => state.home.blogPosts)
  const [latest, setLatest] = useState(blogPosts)

  useEffect(() => {
    setLatest(blogPosts.slice(0, isLargeOrUpScreen ? 3 : 4))
  }, [isLargeOrUpScreen, blogPosts])

  return (
    <>
      <TitleContainer>
        <CardGroupHeader pretitleId="home.blog.subtitle" titleId="home.blog.title" />
        <TitleButton
          component="a"
          href="https://carto.com/blog/"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          size="small"
          endIcon={<LaunchOutlined />}
        >
          <FormattedMessage id="home.blog.visit" />
        </TitleButton>
      </TitleContainer>
      <Grid container spacing={3}>
        {latest.map((post, i) => {
          return (
            <Grid key={i} item xs={12} sm={6} lg={4}>
              <HomeBlogCard post={post} />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

export default HomeBlogLatestPosts
